import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-prepayments',
  templateUrl: './prepayments.component.html',
  styleUrls: ['./prepayments.component.css']
})
export class PrepaymentsComponent implements OnInit {
    public argType: string;

    public argValue: string;

    public setting?: Setting;

    public itemsListPrepayments: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(468, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadPrepayments() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListPrepayments = await this.datatask.Post(442, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadSetting();
        this.loadPrepayments();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    amount_total_topay: string;
    amount_paid_before: string;
    amount_topay_rest: string;
    businessco_companyname: string;
    show_setting: string;
    prepayments_add_new_always: string;
}
